// Rendered size per marker type. The marker images are shared with other
// screens, so sizing happens through the google.maps icon options rather than
// by editing the assets.
export const DEFAULT_MARKER_SIZES = {
  start: 30,
  stop: 32,
  cancelled: 28,
  end: 38,
  origin: 32
};

const toSize = size =>
  typeof size === 'number' ? { width: size, height: size } : size;

const mapsApi = () =>
  typeof window !== 'undefined' && window.google && window.google.maps;

// centerAnchor keeps a round marker (and its label) centred on the coordinate.
// Without it google.maps anchors at the bottom centre, which is what pin
// shaped icons need.
export const scaledIcon = (url, size, centerAnchor = false) => {
  const maps = mapsApi();

  // Markers can be built before the maps script has loaded, so fall back to the
  // plain url. The map components re-render once they are ready and the sized
  // icon replaces it.
  if (!maps) {
    return url;
  }

  const { width, height } = toSize(size);
  const icon = { url, scaledSize: new maps.Size(width, height) };

  if (centerAnchor) {
    icon.anchor = new maps.Point(width / 2, height / 2);
    icon.labelOrigin = new maps.Point(width / 2, height / 2);
  }

  return icon;
};

// Google snaps leg end_location to the road, so it won't exactly equal the
// saved stop coordinates. Match stops by proximity instead of equality.
const CANCELLED_MATCH_METERS = 75;

const distanceMeters = (lat1, lng1, lat2, lng2) => {
  const toRad = deg => (deg * Math.PI) / 180;
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
  return 6371000 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
};

// points are { lat, lng } objects.
export const isNearAnyPoint = (lat, lng, points = []) =>
  points.some(
    p => distanceMeters(lat, lng, p.lat, p.lng) <= CANCELLED_MATCH_METERS
  );

export const resolveMarkerSizes =(markerSizes = {}) => ({
  ...DEFAULT_MARKER_SIZES,
  ...markerSizes
});
